export const toastConstants = {
	SUCCESS: "TOAST_SUCCESS",
	ERROR: "TOAST_ERROR",
	CLEAR: "TOAST_CLEAR",
};
